// extracted by mini-css-extract-plugin
export default {"customerItem":"CustomerPhoto_customerItem__LnZIH"};